export const EXTENSION_FETCH = 'EXTENSION/FETCH';
export const EXTENSION_FETCH_SUCCESS = 'EXTENSION/FETCH_SUCCESS';
export const EXTENSION_FETCH_FAILURE = 'EXTENSION/FETCH_FAILURE';
export const EXTENSION_SAVE = 'EXTENSION/SAVE';
export const EXTENSION_SAVE_SUCCESS = 'EXTENSION/SAVE_SUCCESS';
export const EXTENSION_SAVE_FAILURE = 'EXTENSION/SAVE_FAILURE';
export const EXTENSION_EDIT = 'EXTENSION/EDIT';
export const EXTENSION_EDIT_DETAILS = 'EXTENSION/EDIT_DETAILS';
export const EXTENSION_EDIT_DETAILS_COMMERCIALS =
  'EXTENSION/EDIT_DETAILS_COMMERCIALS';
export const EXTENSION_REMOVE_COMMERCIAL = 'EXTENSION/REMOVE_COMMERCIAL';
export const EXTENSION_ADD_URL = 'EXTENSION/ADD_URL';
export const EXTENSION_REMOVE_URL = 'EXTENSION/REMOVE_URL';
export const EXTENSION_CREATE_EMPTY = 'EXTENSION/CREATE_EMPTY';
export const EXTENSION_ADD_MEDIA = 'EXTENSION/ADD_MEDIA';
export const EXTENSION_REMOVE_MEDIA = 'EXTENSION/REMOVE_MEDIA';
export const EXTENSION_SET_MAIN_MEDIA = 'EXTENSION/SET_MAIN_MEDIA';
export const EXTENSION_EDIT_MEDIA = 'EXTENSION/EDIT_MEDIA';
export const EXTENSION_TAG_DELETE = 'EXTENSION/TAG_DELETE';
export const EXTENSION_TAG_ADD = 'EXTENSION/TAG_ADD';

const initialState = {};

export const fetchExtension = id => ({
  type: EXTENSION_FETCH,
  payload: { id },
});

export const saveExtension = extension => ({
  type: EXTENSION_SAVE,
  payload: { extension },
});

export const editExtension = data => ({
  type: EXTENSION_EDIT,
  payload: data,
});

export const editExtensionDetails = data => ({
  type: EXTENSION_EDIT_DETAILS,
  payload: data,
});

export const editExtensionDetailsCommercials = data => ({
  type: EXTENSION_EDIT_DETAILS_COMMERCIALS,
  payload: data,
});

export const removeExtensionCommercial = index => ({
  type: EXTENSION_REMOVE_COMMERCIAL,
  payload: { index },
});

export const addExtensionUrl = data => ({
  type: EXTENSION_ADD_URL,
  payload: data,
});

export const removeExtensionUrl = index => ({
  type: EXTENSION_REMOVE_URL,
  payload: { index },
});

export const createEmptyExtension = id => ({
  type: EXTENSION_CREATE_EMPTY,
  payload: id,
});

export const addExtensionMedia = data => ({
  type: EXTENSION_ADD_MEDIA,
  payload: { data },
});

export const removeExtensionMedia = index => ({
  type: EXTENSION_REMOVE_MEDIA,
  payload: { index },
});

export const setExtensionMainMedia = index => ({
  type: EXTENSION_SET_MAIN_MEDIA,
  payload: { index },
});

export const editExtensionMainMedia = (index, media) => ({
  type: EXTENSION_EDIT_MEDIA,
  payload: { index, media },
});

export const deleteTag = tag => ({
  type: EXTENSION_TAG_DELETE,
  payload: { tag },
});

export const addTag = (tag, type) => ({
  type: EXTENSION_TAG_ADD,
  payload: { tag, type },
});

export const extensionReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case EXTENSION_FETCH_SUCCESS:
    case EXTENSION_SAVE_SUCCESS: {
      return { ...payload };
    }
    case EXTENSION_EDIT: {
      return {
        ...state,
        ...payload,
      };
    }
    case EXTENSION_EDIT_DETAILS: {
      return {
        ...state,
        details: { ...state.details, ...payload },
      };
    }
    case EXTENSION_EDIT_DETAILS_COMMERCIALS: {
      const commercials = state.details.commercials
        ? state.details.commercials
        : [];
      return {
        ...state,
        details: {
          ...state.details,
          commercials: [...commercials, payload],
        },
      };
    }
    case EXTENSION_REMOVE_COMMERCIAL: {
      return {
        ...state,
        details: {
          ...state.details,
          commercials: [
            ...state.details.commercials.slice(0, payload.index),
            ...state.details.commercials.slice(payload.index + 1),
          ],
        },
      };
    }
    case EXTENSION_ADD_URL: {
      return {
        ...state,
        urls: [...state.urls, { ...payload }],
      };
    }
    case EXTENSION_REMOVE_URL: {
      return {
        ...state,
        urls: [
          ...state.urls.slice(0, payload.index),
          ...state.urls.slice(payload.index + 1),
        ],
      };
    }
    case EXTENSION_FETCH_FAILURE: {
      console.error(EXTENSION_FETCH_FAILURE);
      return state;
    }
    case EXTENSION_CREATE_EMPTY: {
      return {
        name: '',
        details: {
          commercials: [],
        },
        description: '',
        media: [],
        urls: [],
        tags: [],
      };
    }
    case EXTENSION_ADD_MEDIA: {
      return {
        ...state,
        media: [...state.media, { ...payload.data }],
      };
    }
    case EXTENSION_REMOVE_MEDIA: {
      return {
        ...state,
        media: [
          ...state.media.slice(0, payload.index),
          ...state.media.slice(payload.index + 1),
        ],
      };
    }
    case EXTENSION_SET_MAIN_MEDIA: {
      const media = state.media.map((item, index) => {
        item.main = index === payload.index;
        return item;
      });

      return {
        ...state,
        media,
      };
    }
    case EXTENSION_EDIT_MEDIA: {
      return {
        ...state,
        media: [
          ...state.media.slice(0, payload.index),
          {
            ...state.media[payload.index],
            ...payload.media,
          },
          ...state.media.slice(payload.index + 1),
        ],
      };
    }
    case EXTENSION_TAG_DELETE: {
      const tags = state.tags.filter(tag => tag !== payload.tag);
      return {
        ...state,
        tags,
      };
    }
    case EXTENSION_TAG_ADD: {
      return {
        ...state,
        tags: [...state.tags, payload.tag],
      };
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/extension.reducer.js